<template>
  <v-container fluid>
    <v-row>
      <v-flex xs12 sm12 m12 lg12 ex12>

        <!-- Otvorene stavke partnera (type 3) - novi prikaz. Stari ispod ostaje za kartice. -->
        <div v-if="novi" class="os">
          <div class="os-head">
            <div class="os-firma">
              <div class="os-firma-ime">{{ comp.CompanyNameShort }}</div>
              <div>{{ comp.CompanyStreet }} {{ comp.CompanyBuildingNameNumber }}</div>
              <div>{{ comp.CompanyPostcode }} {{ comp.CompanyCity }}</div>
              <div>OIB: {{ comp.CompanyVATID }}</div>
            </div>
            <div class="os-naslov">
              <h2>{{ headUp }}</h2>
              <div class="os-partner">{{ imePartnera }}</div>
              <div class="os-meta">
                OIB: {{ oibPartnera }}<span class="os-sep">·</span>{{ currency }}<span class="os-sep">·</span>stanje na {{ doDatumaTxt }}<span class="os-sep">·</span>konta {{ head.fromAccount }}–{{ head.toAccount }}
              </div>
            </div>
            <div class="os-akcije">
              <v-btn small outlined color="primary" @click="printaj">Printaj</v-btn>
              <v-btn small outlined @click="print(2)">Izv.Ot.Stavaka</v-btn>
              <v-btn small outlined @click="print(3)">Opomena</v-btn>
              <v-btn small outlined @click="uExcel">Excel</v-btn>
              <v-btn small depressed color="primary" @click="connect">Poveži</v-btn>
            </div>
          </div>

          <div v-if="sazetak.uplata > 0" class="os-upozorenje" role="note">
            <span class="os-uzvik">!</span>
            <p>
              <b>{{ sazetak.uplata }} {{ oblik(sazetak.uplata, 'nepovezana uplata', 'nepovezane uplate', 'nepovezanih uplata') }}, ukupno {{ formatPrice(sazetak.iznosUplata) }} {{ currency }}.</b>
              Dok nisu povezane s računima, računi izgledaju neplaćeni — opomena bi mogla tražiti iznos koji je partner već platio.
            </p>
            <v-btn small outlined color="orange darken-3" @click="connect">Poveži uplate</v-btn>
          </div>

          <div class="os-sazetak">
            <div class="os-kut">
              <span>Otvoreni računi</span>
              <b>{{ formatPrice(sazetak.iznosRacuna) }}</b>
              <small>{{ sazetak.racuna }} {{ oblik(sazetak.racuna, 'račun', 'računa', 'računa') }}</small>
            </div>
            <div class="os-kut">
              <span>Nepovezane uplate</span>
              <b>{{ sazetak.uplata ? formatPrice(sazetak.iznosUplata) : '–' }}</b>
              <small>{{ sazetak.uplata ? sazetak.uplata + ' ' + oblik(sazetak.uplata, 'uplata', 'uplate', 'uplata') : 'nema' }}</small>
            </div>
            <div class="os-kut os-istaknuto">
              <span>Saldo</span>
              <b :class="{neg: sazetak.saldo < 0}">{{ formatPrice(Math.abs(sazetak.saldo)) }} {{ saldoStrana(sazetak.saldo) }}</b>
              <small>{{ currency }}</small>
            </div>
            <div class="os-kut os-lose">
              <span>Dospjelo</span>
              <b>{{ sazetak.dospjelo ? formatPrice(sazetak.dospjelo) : '–' }}</b>
              <small>na {{ doDatumaTxt }}</small>
            </div>
            <div class="os-kut">
              <span>Najstarije dospijeće</span>
              <b>{{ sazetak.najviseDana ? sazetak.najviseDana + ' dana' : '–' }}</b>
            </div>
          </div>

          <div class="os-alati">
            <span class="os-oznaka">Prikaži</span>
            <div class="os-seg" role="group" aria-label="Filtar stavaka">
              <button v-for="f in filteri" :key="f.k" type="button" :aria-pressed="String(filtar === f.k)" @click="filtar = f.k">{{ f.naziv }}</button>
            </div>
            <span class="os-broj">{{ prikaz.length }} {{ oblik(prikaz.length, 'stavka', 'stavke', 'stavaka') }} · sortiranje klikom na naslov stupca</span>
          </div>

          <div v-if="ucitano && redci.length === 0" class="os-prazno">
            Partner nema otvorenih stavaka na {{ doDatumaTxt }}.
          </div>
          <div v-else class="os-scroll">
            <table class="os-tbl">
              <thead>
                <tr>
                  <th class="l">Vrsta</th>
                  <th class="l"><button type="button" @click="sortiraj('dokument')">Dokument<span class="os-smjer">{{ strelica('dokument') }}</span></button></th>
                  <th class="l"><button type="button" @click="sortiraj('veza')">Veza<span class="os-smjer">{{ strelica('veza') }}</span></button></th>
                  <th class="l"><button type="button" @click="sortiraj('datum')">Datum<span class="os-smjer">{{ strelica('datum') }}</span></button></th>
                  <th class="l"><button type="button" @click="sortiraj('dospijece')">Dospijeće<span class="os-smjer">{{ strelica('dospijece') }}</span></button></th>
                  <th><button type="button" @click="sortiraj('dana')">Dana<span class="os-smjer">{{ strelica('dana') }}</span></button></th>
                  <th class="l">Opis</th>
                  <th><button type="button" @click="sortiraj('iznos')">Iznos<span class="os-smjer">{{ strelica('iznos') }}</span></button></th>
                  <th>Zatvoreno</th>
                  <th><button type="button" @click="sortiraj('otvoreno')">Otvoreno<span class="os-smjer">{{ strelica('otvoreno') }}</span></button></th>
                  <th>Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in prikaz" :key="r.kljuc">
                  <td><span class="os-tag" :class="{uplata: !r.jeRacun}">{{ r.vrsta }}</span></td>
                  <td class="doc">{{ r.dokument }}</td>
                  <td class="doc">{{ r.veza }}</td>
                  <td class="doc">{{ r.datumTxt }}</td>
                  <td class="doc">{{ r.dospijeceTxt }}</td>
                  <td class="num dana" :class="{kasni: r.dana > 0}">{{ danaTekst(r) }}</td>
                  <td class="opis">{{ r.opis }}</td>
                  <td class="num">{{ formatPrice(r.iznos) }}</td>
                  <td class="num" :class="{nula: !r.zatvoreno}">{{ r.zatvoreno ? formatPrice(r.zatvoreno) : '–' }}</td>
                  <td class="num" :class="{neg: !r.jeRacun}">{{ r.jeRacun ? '' : '−' }}{{ formatPrice(r.otvoreno) }}</td>
                  <td class="num" :class="{neg: r.saldo < 0}">{{ formatPrice(Math.abs(r.saldo)) }}<span class="os-dp">{{ saldoStrana(r.saldo) }}</span></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="9">UKUPNO {{ currency }}<span v-if="filtar !== 'sve'" class="os-napomena"> · samo prikazane stavke</span></td>
                  <td class="num" :class="{neg: ukupnoPrikaz < 0}">{{ predznak(ukupnoPrikaz) }}</td>
                  <td class="num" :class="{neg: ukupnoPrikaz < 0}">{{ formatPrice(Math.abs(ukupnoPrikaz)) }}<span class="os-dp">{{ saldoStrana(ukupnoPrikaz) }}</span></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div v-if="redci.length" class="os-kontrola">
            <span>Saldo = otvoreni računi − nepovezane uplate</span>
            <span class="os-jednadzba">{{ formatPrice(sazetak.iznosRacuna) }} − {{ formatPrice(sazetak.iznosUplata) }} = {{ predznak(sazetak.saldo) }}</span>
          </div>
        </div>

        <div v-else-if="showOpenCard">

                <v-layout row style="border-bottom:solid 1px;">
                    <v-flex xs4>
                        <h4><b><i>{{comp.CompanyNameShort}}</i></b></h4>
                        {{comp.CompanyStreet}} {{comp.CompanyBuildingNameNumber}}   <br />                
                        {{comp.CompanyPostcode}} {{comp.CompanyCity}}<br />
                         OIB: {{comp.CompanyVATID}}
                    </v-flex>
                    <v-flex xs3>
                      <h4>{{headUp}} {{currency}}</h4>

                      <h4><b><i>{{partner.partnerName}}</i></b></h4>
                      {{partner.partnerStreet}} {{partner.partnerBuildingNameNumber}}   <br />                
                      {{partner.partnerPostcode}} {{partner.partnerCity}}<br />
                      OIB: {{partner.partnerVATID}}, {{partner.partneremail}}
                  </v-flex>
                    <v-flex xs 5>
                      <p class="text-md-left">
                          Datum izvještaja: {{PrintDate}}<br />
                          Telefon: {{comp.CompanyPhones}}<br />
                          email: {{comp.Companyemail}}<br />
                          <v-btn @click="print(1)" class="mr-2">Print</v-btn>
                          <span v-if="printOptions === 1">
                            <v-btn @click="print(2)" class="mr-2">Izv.Ot.Stavaka</v-btn>
                            <v-btn @click="print(3)" class="mr-2">Opomena</v-btn>
                          </span>
                          <v-btn @click="sortCard()" class="mr-2">Sort{{(sortType > 0 ? '(' + sortType + ')' : '')}}</v-btn>
                          <v-btn @click="connect" class="mr-2">Poveži</v-btn>
                      </p>
                    </v-flex>
              </v-layout>

            <v-layout row style="border-bottom:solid 1px; border-top:solid 1px;">

                    <v-flex xs1 class="text-left" >
                     Rb.  Vrsta
                    </v-flex>
                    <v-flex xs1 class="text-left">
                      Broj dok.
                    </v-flex>
                    <v-flex xs1 class="text-left">
                      Veza
                      <span v-if="sortType == 1" ><v-icon>mdi-arrow-down-bold</v-icon> </span>
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      Datum knjiženja 
                      <span v-if="sortType == 0 || sortType == 2" ><v-icon>mdi-arrow-down-bold</v-icon> </span>
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      Datum dokumenta
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      Datum dospijeća
                    </v-flex>
                    <v-flex xs2 class="text-left">
                      Opis
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      Konto
                    </v-flex>
                    <v-flex xs1 class="text-right" >
                      Duguje
                      <span v-if="sortType == 3" ><v-icon>mdi-arrow-down-bold</v-icon> </span>
                    </v-flex>
                    <v-flex xs1 class="text-right" >
                      Potražuje
                      <span v-if="sortType == 4" ><v-icon>mdi-arrow-down-bold</v-icon> </span>
                    </v-flex>
                    <v-flex xs1 class="text-right" >
                      Saldo
                      <span v-if="sortType == 5" ><v-icon>mdi-arrow-down-bold</v-icon> </span>
                    </v-flex>

              </v-layout>

                <v-layout row v-for="item in pItems" :key="item.id">
                    <v-flex xs1 class="text-left" >
                      {{ item.itBookName }}
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      {{ item.itInvoice }}
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      {{ (item.account2 === '12'  ? (item.invoiceOutNumber ? item.invoiceOutNumber : '') : (item.invoiceInNumber ? item.invoiceInNumber : ''))  + (item.BusinessYearInvoice ?  '/' + item.BusinessYearInvoice : '') }}
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      {{ localDate(item.BookingDate) }}
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      {{ localDate(item.InvoiceDate) }}
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      {{ localDate(item.InvoicePaymentDeadlineDate) }}
                    </v-flex>
                    <v-flex xs2 class="text-center" style="font-size:12px;">
                      {{ item.Description }}
                    </v-flex>
                    <v-flex xs1 class="text-left" >
                      {{ item.account4 }}
                    </v-flex>
                    <v-flex xs1 class="text-right" >
                      {{ formatPrice(parseFloat(item.pDebit)) }}
                    </v-flex>
                    <v-flex xs1 class="text-right" >
                      {{ formatPrice(parseFloat(item.pCredit)) }}
                    </v-flex>
                    <v-flex xs1 class="text-right" >
                      {{ formatPrice(parseFloat(item.CreditDebit)) }}
                    </v-flex>
                    

            </v-layout>
            <v-layout row style="border-top:solid 1px;">
              <v-flex xs9 class="text-xs-right">

              </v-flex>

              <v-flex xs1 class="text-right">
                {{ formatPrice(Total1) }}
              </v-flex>
              <v-flex xs1 class="text-right">
                {{ formatPrice(Total2) }}
              </v-flex>
              <v-flex xs1 class="text-right">
                {{ formatPrice(Total5) }}
              </v-flex>

            </v-layout>
        </div>
      </v-flex>
     
      <MainLedgerPrintCard3 ref="prnt" :card="card" :printType="printType"/>

      <!-- Upozorenje prije opomene: nepovezana uplata znaci da racun izgleda
           neplacen iako mozda nije, pa bi opomena trazila vec placen iznos. -->
      <v-dialog v-model="upozorenjeOpomena" max-width="560">
        <v-card>
          <v-card-title class="text-h6">Partner ima nepovezane uplate</v-card-title>
          <v-card-text>
            <p class="mb-2">
              Nepovezanih uplata: <b>{{ nepovezane.broj }}</b>,
              ukupno <b>{{ formatPrice(nepovezane.iznos) }} {{ currency }}</b>.
            </p>
            <p class="mb-0">
              Dok uplate nisu povezane s računima, računi na opomeni izgledaju neplaćeni.
              Opomena bi tako mogla tražiti iznos koji je partner već platio.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="upozorenjeOpomena = false">Odustani</v-btn>
            <v-btn text color="orange darken-2" @click="ispisiOpomenuIpak">Ipak ispiši opomenu</v-btn>
            <v-btn color="primary" @click="poveziPrijeOpomene">Poveži prvo</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import MainLedgerPrintCard3 from './MainLedgerPrintCard3'
import MainLedgerZatvaranjeService from '@/services/MainLedgerZatvaranjeService'
import {gradiRedke, saldaRedom, sazmi, racuniNaDuguje, oznakaSalda, mnozina} from './otvoreneStavke'
import {printOpenItemsPdf, printPartnerLetterPdf} from './mainLedgerPdf'
import PartnerService from '@/services/PartnerService'
import {exportOpenItemsXlsx} from './mainLedgerXlsx'
//import {checkPartners} from '../MainLedger/mainledgerHelper'
import { testLastUpdate } from '@/services/TestLastUpdate'
import {dynamicSort, round, doZeros} from '@/snippets/allSnippets'
import dayjs from 'dayjs'
import { domacaValuta } from '@/snippets/domacaValuta'

export default {
  name: 'mainledgercard3',
  props: ['items', 'head', 'showEUR'],
  data () {
    return {
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      comp: {},
      error: null,
      localError: false,
      newUser: {},
      size: 'sm',
      havePath: '',
      Total1: 0,
      Total2: 0,
      Total3: 0,
      Total4: 0,
      Total5: 0,
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      pItems: [],
      mainQuery2: {},
      partner: {},
      partners: [],
      card: {},
      mainQuery: {},
      printType: 1,
      typePartner: null,
      headUp: '',
      printOptions: 1,
      sortType: 0,
      exRate: 1,
      currency: 'EUR',
      showOpenCard: true,
      upozorenjeOpomena: false,
      nepovezane: {broj: 0, iznos: 0},
      novi: false,
      ucitano: false,
      redci: [],
      filtar: 'sve',
      sortK: 'datum',
      sortSmjer: 1,
      saldoItems: [],
      key: 1
    }
  },
  components: {
    MainLedgerPrintCard3
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }
    
    this.exRate = this.$store.state.defExRate ? this.$store.state.defExRate : 1

    if (!this.showEUR) {
      this.exRate = 1
    }
    this.currency = domacaValuta(this.$store.state.businessYear)
    //console.log('card 3 mount head', this.head, this.items, this.exRate)
    const typePartner = this.head.fromAccount ? this.head.fromAccount.substr(0,2) : ''
    if (this.head.type && this.head.type === 3) {
      this.headUp = typePartner === '12' ? this.lang.OpenStatementBuyer : this.lang.OpenStatementSupp
      this.printOptions = 1
      this.novi = true
    }
    if (this.head.subtype && this.head.subtype === 6) {
      this.headUp = typePartner === '12' ? this.lang.CardBuyer : this.lang.CardSupp
      this.printOptions = 2
    }

    this.PrintDate = dayjs(new Date()).format('DD.MM.YYYY, H:mm')
    this.comp = this.$store.state.companyActiv ? this.$store.state.companyActiv : {}
    if (this.$store.state.companyid) {
      this.mainQuery.CompanyId = this.$store.state.companyid
    }
    //await checkPartners(0)
    await testLastUpdate()
    if (this.$store.state.partnerStore) {
      this.partners = this.$store.state.partnerStore
    }
    //this.partners = (await PartnerService.index()).data.partners


    // Otvorene stavke partnera racunaju se kao na ekranu Zatvaranje stavaka.
    // Vidi otvoreneIzZatvaranja(). Stari nacin ispod ostaje za karticu (subtype 6).
    if (this.head.type && this.head.type === 3) {
      await this.otvoreneIzZatvaranja()
      return
    }

    // check for open invoices
    const locItems =[]
    this.items.map(itm=> {
      const objUp = {
        newID: typePartner === '12' ? doZeros(round(itm.invoiceOutNumber,0).toString(), round(itm.BusinessYear,0).toString()) : doZeros(round(itm.invoiceInNumber,0).toString(), round(itm.BusinessYear,0).toString())
      }
      const objUp2 = {...itm, ...objUp}
      locItems.push(objUp2)
    })
    console.log('locItems', locItems)


//     const arr = [{"shape":"square","color":"red","used":1,"instances":1},{"shape":"square","color":"red","used":2,"instances":1},{"shape":"circle","color":"blue","used":0,"instances":0},{"shape":"square","color":"blue","used":4,"instances":4},{"shape":"circle","color":"red","used":1,"instances":1},{"shape":"circle","color":"red","used":1,"instances":0},{"shape":"square","color":"blue","used":4,"instances":5},{"shape":"square","color":"red","used":2,"instances":1}];

// const result = [...arr.reduce((r, o) => {
//   const key = o.shape + '-' + o.color;
  
//   const item = r.get(key) || Object.assign({}, o, {
//     used: 0,
//     instances: 0
//   });
  
//   item.used += o.used;
//   item.instances += o.instances;

//   return r.set(key, item);
// }, new Map).values()];

// console.log(result);


    const result = [...locItems.reduce((r, o) => {
      const key = o.newID;
      
      const item = r.get(key) || Object.assign({}, o, {
        Debit: 0,
        Credit: 0
      });
      
      item.Debit += o.Debit;
      item.Credit += o.Credit;

      return r.set(key, item);
    }, new Map).values()];
  

    result.map(r => {
      if (round(Math.abs(r.Debit)-Math.abs(r.Credit) , 2) !== 0) {
        this.saldoItems.push(r)
      }
    })
    
    this.Total1 = 0
    this.Total2 = 0
    this.Total3 = 0
    this.Total4 = 0
    let itLine = 0
    let partnerVATID = null

    if (this.saldoItems) {
      this.saldoItems.sort((a,b) => (a.BookingDate > b.BookingDate) ? 1 : ((b.BookingDate > a.BookingDate) ? -1 : 0))
      this.saldoItems.map(item => {
        itLine += 1
        const pDebit = item.totalDebit && item.totalDebit !== 0 ? round((parseFloat(item.totalDebit) / this.exRate),2) : round((parseFloat(item.Debit) / this.exRate),2)
        const pCredit = item.totalCredit && item.totalCredit !== 0 ? round((parseFloat(item.totalCredit) / this.exRate),2) : round((parseFloat(item.Credit) / this.exRate),2)
        this.Total1 += pDebit
        this.Total2 += pCredit
        //this.Total3 += parseFloat(item.DebitForegin)
        //this.Total4 += parseFloat(item.CreditForegin)
        partnerVATID = item.partnerVATID ? item.partnerVATID : null
        let inNr = ''
        if (typeof item.invoiceInNumber === 'number') {
          inNr = parseInt(item.invoiceInNumber)
        }
        if (typeof item.invoiceInNumber !== 'number') {
          inNr = item.invoiceInNumber && item.invoiceInNumber.trim().length > 0 ? item.invoiceInNumber.trim() : ''
        }
        let outNr = ''
        if (typeof item.invoiceOutNumber === 'number') {
          outNr = parseInt(item.invoiceOutNumber)
        }
        if (typeof item.invoiceOutNumber !== 'number') {
          outNr = item.invoiceOutNumber && item.invoiceOutNumber.trim().length > 0 ? item.invoiceOutNumber.trim() : ''
        }

        let itInvoice
        if (item.BookName.substring(0,3) === 'IRA' || item.BookName.substring(0,3) === 'URA') {
          itInvoice = item.BookName.substring(0,3) === 'URA'? inNr : outNr
        }
        if (item.BookName.substring(0,2) === 'PS') {
          itInvoice = parseInt(item.invoiceInNumber) > 0 ? inNr : outNr
        }
        if (item.BookName.substring(0,3) === 'TEM') {
          itInvoice = item.BookID ? parseInt(item.BookID) : ''
        }
         if (item.BookName.substring(0,2) === 'BS') {
          itInvoice = item.BookID ? parseInt(item.BookID) : ''
        }

        const bookName = item.BookName !== 'BS' ? item.BookName : 'Izv.'
        const object2 = {
          pDebit: pDebit,
          pCredit: pCredit, 
          itBookName: itLine + '. ' + bookName,
          CreditDebit: this.Total1 - this.Total2,
          itInvoice: itInvoice,
          locBookName: bookName
        }
        const object3 = {...item, ...object2}
        this.pItems.push(object3)
      })
    }
    
    this.Total5 = this.Total1 - this.Total2
    this.partner = partnerVATID ? this.partners.find(partner => (partner.partnerVATID === partnerVATID)) : {}
    this.card = {...this.head}
    this.card.partner = this.partner
    this.card.items = this.pItems
    //this.card = {...this.card, ...this.lastOne}
    this.card.Total1 = this.Total1
    this.card.Total2 = this.Total2
    this.card.Total5 = this.Total5
    this.card.headUp = this.headUp ? this.headUp : ''

    // if (partnerVATID) {
    //   this.mainQuery2.partnerVATID = partnerVATID
    // }
    // await PartnerService.check(this.mainQuery2)
    // .then(res => {
    //   if (res.data.partner) {
    //     this.partner = res.data.partner
    //   }                
    // })
    // .catch(err => {
    //   this.error = err.data
    // })

  },
  computed: {
    naDuguje () {
      return racuniNaDuguje(this.head.fromAccount)
    },
    sazetak () {
      return sazmi(this.redci)
    },
    filteri () {
      return [
        {k: 'sve', naziv: 'Sve'},
        {k: 'racuni', naziv: 'Računi'},
        {k: 'uplate', naziv: 'Uplate'},
        {k: 'dospjelo', naziv: 'Samo dospjelo'}
      ]
    },
    prikaz () {
      let r = this.redci
      if (this.filtar === 'racuni') { r = r.filter(x => x.jeRacun) }
      if (this.filtar === 'uplate') { r = r.filter(x => !x.jeRacun) }
      if (this.filtar === 'dospjelo') { r = r.filter(x => x.jeRacun && x.dana > 0) }
      const kljucevi = {
        dokument: x => x.dokument,
        veza: x => x.veza,
        datum: x => String(x.datum),
        dospijece: x => String(x.dospijece),
        dana: x => (x.dana === null ? -100000 : x.dana),
        iznos: x => x.iznos,
        otvoreno: x => (x.jeRacun ? x.otvoreno : -x.otvoreno)
      }
      const kljuc = kljucevi[this.sortK] || kljucevi.datum
      const smjer = this.sortSmjer
      const sortirano = [...r].sort((a, b) => {
        const va = kljuc(a)
        const vb = kljuc(b)
        const c = typeof va === 'string' ? va.localeCompare(vb, 'hr', {numeric: true}) : va - vb
        return c * smjer || a.kljuc - b.kljuc
      })
      return saldaRedom(sortirano)
    },
    ukupnoPrikaz () {
      return this.prikaz.length ? this.prikaz[this.prikaz.length - 1].saldo : 0
    },
    imePartnera () {
      if (this.partner && this.partner.partnerName) { return this.partner.partnerName }
      const d = this.redci.find(x => x.partnerName)
      return d ? d.partnerName : ''
    },
    oibPartnera () {
      return (this.partner && this.partner.partnerVATID) || this.head.partnerVATID || ''
    },
    doDatumaTxt () {
      return dayjs(this.head.docToDate || new Date()).format('DD.MM.YYYY')
    }
  },
  methods: {
    // Otvorene stavke iz istog izracuna kao Zatvaranje stavaka: prave veze i stare
    // veze po broju racuna, unutar jedne poslovne godine. Staro grupiranje po broju
    // racuna nije vidjelo veze napravljene na ekranu Zatvaranje stavaka, a uplate
    // bez broja racuna slagalo je u lazne grupe "0/godina".
    //
    // Redak zadrzava oblik koji citaju ekran i ispisi (Print, Izv.Ot.Stavaka,
    // Opomena): pDebit/pCredit su OTVORENI iznosi. Debit/Credit ostaju izvorni,
    // jer ih ispis koristi kao uvjet na kojoj je strani iznos.
    async otvoreneIzZatvaranja () {
      const partnerVATID = this.head.partnerVATID ? this.head.partnerVATID
        : (this.items && this.items.length && this.items[0].partnerVATID ? this.items[0].partnerVATID : null)
      let dokumenti = []
      try {
        const {data} = await MainLedgerZatvaranjeService.stanje({
          CompanyId: this.$store.state.companyid,
          fromAccount: this.head.fromAccount,
          toAccount: this.head.toAccount,
          partnerVATID: partnerVATID,
          BusinessYear: this.head.BusinessYear,
          doDatuma: this.head.docToDate
        })
        dokumenti = data && data.dokumenti ? data.dokumenti : []
      } catch (err) {
        dokumenti = []
      }
      this.redci = gradiRedke(dokumenti, this.head.docToDate, this.exRate)
      const otvoreni = dokumenti.filter(d => d.otvoreno > 0.005)
        .sort((a, b) => (a.BookingDate > b.BookingDate ? 1 : (b.BookingDate > a.BookingDate ? -1 : a.id - b.id)))

      this.Total1 = 0
      this.Total2 = 0
      this.pItems = []
      let itLine = 0
      otvoreni.forEach(d => {
        itLine += 1
        const naDuguje = String(d.account4 || '').substring(0, 2) !== '22'
        const iznos = round(d.otvoreno / this.exRate, 2)
        // Racun kupca i uplata dobavljacu stoje na duguje, ostalo na potrazuje.
        const duguje = d.jeRacun === naDuguje
        const pDebit = duguje ? iznos : 0
        const pCredit = duguje ? 0 : iznos
        this.Total1 += pDebit
        this.Total2 += pCredit

        const inNr = d.invoiceInNumber ? String(d.invoiceInNumber).trim() : ''
        const outNr = d.invoiceOutNumber ? String(d.invoiceOutNumber).trim() : ''
        const book = d.BookName ? String(d.BookName) : ''
        let itInvoice = ''
        if (book.substring(0, 3) === 'IRA' || book.substring(0, 3) === 'URA') {
          itInvoice = book.substring(0, 3) === 'URA' ? inNr : outNr
        }
        if (book.substring(0, 2) === 'PS') { itInvoice = parseInt(inNr) > 0 ? inNr : outNr }
        if (book.substring(0, 3) === 'TEM' || book.substring(0, 2) === 'BS') {
          itInvoice = d.BookID ? parseInt(d.BookID) : ''
        }
        const bookName = book !== 'BS' ? book : 'Izv.'

        // Ispis zbraja stranu samo ako je izvorni iznos na toj strani popunjen. Kod
        // storna (negativan iznos na suprotnoj strani) to ne bi vrijedilo, pa se na
        // lokalnoj kopiji retka upise otvoreni iznos na pravu stranu.
        const Debit = duguje && !parseFloat(d.Debit) ? iznos : d.Debit
        const Credit = !duguje && !parseFloat(d.Credit) ? iznos : d.Credit

        this.pItems.push({
          ...d,
          Debit: Debit,
          Credit: Credit,
          account2: String(d.account4 || '').substring(0, 2),
          pDebit: pDebit,
          pCredit: pCredit,
          itBookName: itLine + '. ' + bookName,
          CreditDebit: this.Total1 - this.Total2,
          itInvoice: itInvoice,
          locBookName: bookName
        })
      })

      this.Total5 = this.Total1 - this.Total2
      this.partner = partnerVATID ? (this.partners.find(pp => pp.partnerVATID === partnerVATID) || {}) : {}
      this.card = {...this.head}
      this.card.partner = this.partner
      this.card.items = this.pItems
      this.card.Total1 = this.Total1
      this.card.Total2 = this.Total2
      this.card.Total5 = this.Total5
      this.card.headUp = this.headUp ? this.headUp : ''
      this.ucitano = true
    },
    oblik (n, jedan, dva, pet) {
      return mnozina(n, jedan, dva, pet)
    },
    saldoStrana (v) {
      return oznakaSalda(v, this.naDuguje)
    },
    predznak (v) {
      return (v < -0.005 ? '−' : '') + this.formatPrice(Math.abs(v))
    },
    danaTekst (r) {
      if (r.dana === null) { return '' }
      if (r.dana > 0) { return String(r.dana) }
      return r.dana === 0 ? 'danas' : 'za ' + (-r.dana)
    },
    // Klik na isti stupac okrece smjer. Iznosi i dani krecu od najveceg.
    sortiraj (k) {
      if (this.sortK === k) {
        this.sortSmjer = -this.sortSmjer
        return
      }
      this.sortK = k
      this.sortSmjer = ['iznos', 'otvoreno', 'dana'].indexOf(k) !== -1 ? -1 : 1
    },
    strelica (k) {
      if (this.sortK !== k) { return '' }
      return this.sortSmjer > 0 ? '↑' : '↓'
    },
    // Papir prati ekran: isti filtar, isti redoslijed, isti saldo.
    zaIzvoz () {
      const f = this.filteri.find(x => x.k === this.filtar)
      return {
        company: this.comp,
        naslov: this.headUp || 'Otvorene stavke',
        partner: {ime: this.imePartnera, oib: this.oibPartnera},
        valuta: this.currency,
        doDatuma: this.head.docToDate,
        fromAccount: this.head.fromAccount,
        toAccount: this.head.toAccount,
        naDuguje: this.naDuguje,
        redci: this.prikaz,
        sazetak: this.sazetak,
        filtar: this.filtar === 'sve' || !f ? '' : f.naziv
      }
    },
    printaj () {
      printOpenItemsPdf(this.zaIzvoz())
    },
    uExcel () {
      exportOpenItemsXlsx(this.zaIzvoz())
    },
    print(type){
      // Prije opomene provjeri ima li partner uplata koje jos nisu povezane s
      // racunima (jeRacun === false dolazi iz izracuna zatvaranja stavaka).
      if (type === 3) {
        const uplate = this.pItems.filter(i => i.jeRacun === false &&
          ((parseFloat(i.pDebit) || 0) + (parseFloat(i.pCredit) || 0)) > 0.005)
        if (uplate.length > 0) {
          this.nepovezane = {
            broj: uplate.length,
            iznos: uplate.reduce((a, i) => a + (parseFloat(i.pDebit) || 0) + (parseFloat(i.pCredit) || 0), 0)
          }
          this.upozorenjeOpomena = true
          return
        }
      }
      this.ispisi(type)
    },
    async ispisi(type) {
      if (this.novi) {
        await this.ispisiDopis(type === 3 ? 'opomena' : 'izvod')
        return
      }
      this.printType = type
      this.$refs.prnt.print(type)
    },
    // Izvod otvorenih stavaka i opomena idu partneru, pa adresa dolazi iz
    // sifrarnika partnera. Stavke su iste kao na ekranu, bez filtra s ekrana.
    async ispisiDopis (vrsta) {
      const oib = this.oibPartnera
      let partner = this.partner && this.partner.partnerName ? {...this.partner} : {}
      if (oib) {
        try {
          const {data} = await PartnerService.show(oib)
          if (data && data.partner) { partner = data.partner }
        } catch (err) {
          // ostaje partner iz ucitanog sifrarnika
        }
      }
      if (!partner.partnerName) { partner.partnerName = this.imePartnera }
      if (!partner.partnerVATID) { partner.partnerVATID = oib }
      printPartnerLetterPdf({
        vrsta: vrsta,
        company: this.comp,
        partner: partner,
        valuta: this.currency,
        naDuguje: this.naDuguje,
        fromAccount: this.head.fromAccount,
        toAccount: this.head.toAccount,
        docFromDate: this.head.docFromDate,
        docToDate: this.head.docToDate,
        redci: this.redci
      })
    },
    ispisiOpomenuIpak() {
      this.upozorenjeOpomena = false
      this.ispisi(3)
    },
    poveziPrijeOpomene() {
      this.upozorenjeOpomena = false
      this.connect()
    },
    // Poveži otvara ekran Zatvaranje stavaka s uvjetima ove kartice. Prije je
    // otvarao stari nacin povezivanja, koji je upisivao broj racuna na uplatu i
    // nije znao jednu uplatu povezati s vise racuna. Signal ide roditelju jer se
    // kartica prikazuje i u analizi i unutar Svi part.otv.
    connect() {
      const oib = (this.partner && this.partner.partnerVATID) || this.head.partnerVATID || null
      this.$emit('otvori-zatvaranje', {
        fromAccount: this.head.fromAccount,
        toAccount: this.head.toAccount,
        partnerVATID: oib,
        partnerId: this.partner && this.partner.id ? this.partner.id : null,
        docFromDate: this.head.docFromDate,
        docToDate: this.head.docToDate,
        BusinessYear: this.head.BusinessYear
      })
    },
    sortCard() {
      this.sortType += 1
      if (this.sortType > 5) {
        this.sortType = 0
      }
      if (this.sortType === 1) {
        this.pItems.sort(dynamicSort("InvoiceNumber"))
      }
      if (this.sortType === 2 || this.sortType === 0) {
        this.pItems.sort(dynamicSort("BookingDate"))
      }
      if (this.sortType === 3) {
        this.pItems.sort(dynamicSort("pDebit"))
      }
      if (this.sortType === 4) {
        this.pItems.sort(dynamicSort("pCredit"))
      }
      if (this.sortType === 5) {
        this.pItems.sort(dynamicSort("CreditDebit"))
      }
    },
    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    close () {
      this.show = false
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>

<style scoped src="./otvoreneStavke.css"></style>
